import clsx from "clsx";
import { useSelector } from "react-redux";

import styles from "./index.module.scss";

/** Телефон и e-mail из state.contacts. */
export default function ContactsInfo({ isBaltex = false }) {
  const { contacts } = useSelector((state) => state.contacts);

  return (
    <div className={clsx(styles.Info, isBaltex && styles.InfoBaltex)}>
      <div>
        <div>Телефон:</div>
        <a href={`tel:${contacts?.phone}`} className={contacts?.calltouchCode}>
          {contacts?.phone}
        </a>
      </div>
      <div>
        <div>Эл. почта</div>
        <a href={`mailto:${contacts?.email}`}>{contacts?.email}</a>
      </div>
    </div>
  );
}
